export default __webpack_public_path__ + "static/media/white-parcel-measure-icon.67e03a01.svg";